module.exports = __webpack_public_path__ + "media/phase1.a2724282.webm";